import React from 'react'
import './src/styles/globals.css'
import Lenis from 'lenis'
import 'lenis/dist/lenis.css'
import Layout from './src/components/Layout'
import { DarkModeProvider } from './src/components/DarkModeProvider'

// Inicializar Lenis solo en el navegador
if (typeof window !== 'undefined') {
  new Lenis({
    autoRaf: true,
    overscroll: true
  })
}

export const wrapPageElement = ({ element }) => {
  return (
    <DarkModeProvider>
      <Layout>{element}</Layout>
    </DarkModeProvider>
  )
}
